module.exports = __webpack_public_path__ + "images/register1.png";